export default __webpack_public_path__ + "static/media/fiLogo.9c9e7eed.png";